import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect } from 'react-router'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Container } from 'reactstrap'
import {
  modalAction,
  authAction,
  projectInformationAction,
  lobAction,
  companyAction,
  departmentAction,
  clientMasterAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  projectInformationSelector,
  lobSelector,
  companySelector,
  departmentSelector,
  clientMasterSelector,
} from './../../selectors'
import {
  searchProjectInformation,
  createProjectApproverList,
  createClientList,
  createPMSupervisorList,
  createProjectManagerList,
} from '../../function'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'
import { project_type } from '../../components/project-information/constants'
import { ProjectForm } from '../../components/project-information/form'
import { ProjectTable } from '../../components/project-information/table'
import SearchbarProject from '../../components/project-information/searchbar/searchbar-project'
import Manual from '../../components/project-information/helper/manual'
import withLayout from '../../helpers/withLayout'
import { DiscardProjectForm } from '../../components/project-information/form/discard-project.js'
import {
  newProjectButton,
  buttonSuccess,
  buttonTryAgain,
} from '../../components/project-information/helper/button'

class ProjectPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getProjectInformationData.projects') &&
    get(nextProps, 'getClientData') &&
    get(nextProps, 'getLOBData')) {
      let types = [...get(nextProps, 'getProjectInformationData.createableProjectType', [])]
      if (types.indexOf('FIXFEE') > -1) {
        types.splice(types.indexOf('FIXFEE'), 1)
        types = ['FIXFEE', ...types]
      }
      if (types.indexOf('COMMON') > -1) {
        types.splice(types.indexOf('COMMON'), 1)
        types = [...types, 'COMMON']
      }
      const project_types = []
      types.map(type => {
        const obj = find(project_type, {
          value: type,
        })
        project_types.push(obj)
        return type
      })
      if (project_types.length !== 0) {
        set(tempState, 'project_types', project_types)
        set(tempState, 'project_type', project_types[0].value)
      }
      const projectInformationUserData = get(nextProps, 'getProjectInformationData.users').filter(u => u.is_active === true)

      const approverList = createProjectApproverList(projectInformationUserData)
      const supervisorList = createPMSupervisorList(projectInformationUserData)
      const managerList = createProjectManagerList(projectInformationUserData)

      const managers = managerList.filter(mng => {
        return mng._id === get(nextProps, 'authData.user._id') || mng.is_project_approver_role
      })

      if (managers.length !== 0) set(tempState, 'project_managers', [...managers])
      set(tempState, 'approvers', approverList)
      set(tempState, 'managers', managerList)
      set(tempState, 'pm_supervisors', supervisorList)

      const lobs = get(nextProps, 'getLOBData')
      if (lobs !== prevState.lobs) {
        set(tempState, 'lobs', orderBy(lobs, ['name'], ['asc']))
      }
      const clients = createClientList(get(nextProps, 'getClientData'))
      const projects = []
      get(nextProps, 'getProjectInformationData.projects').map(p => {
        const project = {}
        const client = find(clients, { _id: p.client_id })
        const lob = find(lobs, { _id: p.lob_id })
        project._id = p._id
        project.client = client ? client.name : ''
        project.name = p.name
        project.lob = lob ? lob.name : ''
        project.project_code = get(p, 'project_code', '')
        project.start_date = moment(p.start_date).format('DD/MM/YYYY')
        project.default_start_date = moment(p.start_date).format('YYYYMMDD')
        project.end_date = moment(p.end_date).format('DD/MM/YYYY')
        project.default_end_date = moment(p.end_date).format('YYYYMMDD')
        // project.project_manager = findProjectManagersByID(p.project_manager_ids, managerList)
        project.key_project_manager = p.key_project_manager
        project.status = p.project_status
        project.created = moment(p.created)
        project.project_type = get(find(project_type, {
          value: p.project_type,
        }), 'label', '-')
        projects.push(project)
        return p
      })
      set(tempState, 'defaultProjectInformation', projects)
      set(tempState, 'projectInformation', projects)
      set(tempState, 'tempProjects', get(nextProps, 'getProjectInformationData.projects'))
      nextProps.resetGetProjectInformation()
    }
    if (get(nextProps, 'createProjectInformationData.createdProject')) {
      const access_token = localStorage.getItem('access_token')
      const status = get(nextProps, 'createProjectInformationData.status')
      const message = get(nextProps, 'createProjectInformationData.message')
      nextProps.showConfirm('createSuccess', status, message)
      if (status === 200) {
        const manager = find(prevState.managers, {
          _id: get(nextProps, 'authData.user._id'),
        })
        set(tempState, 'project_managers', manager)
        set(tempState, 'project_approvers', [])
        set(tempState, 'project_type', prevState.project_types[0].value)
        set(tempState, 'client', '')
        set(tempState, 'project_name', '')
        set(tempState, 'pm_supervisor', '')
        set(tempState, 'company_id', '')
        set(tempState, 'lob_id', '')
        set(tempState, 'department_id', '')
        set(tempState, 'start_date', '')
        set(tempState, 'end_date', '')
        set(tempState, 'remarks', '')
        nextProps.getProjectInformation(access_token)
      }
      nextProps.resetCreateProjectInformation()
    }
    if (JSON.stringify(orderBy(get(nextProps, 'getCompanyData'), ['name'], ['asc']))
    !== JSON.stringify(prevState.companys)) {
      set(tempState, 'companys', orderBy(get(nextProps, 'getCompanyData'), ['name'], ['asc']))
    }
    if (JSON.stringify(orderBy(get(nextProps, 'getDepartmentData'), ['name'], ['asc']))
    !== JSON.stringify(prevState.departments)) {
      set(tempState, 'departments', orderBy(get(nextProps, 'getDepartmentData'), ['name'], ['asc']))
    }
    const clients = createClientList(get(nextProps, 'getClientData'))
    if (JSON.stringify(orderBy(clients, ['label'], ['asc']))
    !== JSON.stringify(prevState.clients)) {
      set(tempState, 'clients', orderBy(clients, ['label'], ['asc']))
    }
    if (get(nextProps, 'getExportURL')) {
      window.open(get(nextProps, 'getExportURL'))
      nextProps.resetExportProjectInformation()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      showCreateProject: false,
      showDiscard: false,
      redirect: false,
      projectID: '',
      defaultProjectInformation: [],
      projectInformation: [],
      project: null,
      selectedStatus: '',
      lobs: [],
      companys: [],
      departments: [],
      approvers: [],
      managers: [],
      pm_supervisors: [],
      clients: [],
      search: '',

      project_types: [],
      project_approvers: [],
      project_managers: [],
      project_type: '',
      client: '',
      project_name: '',
      pm_supervisor: '',
      company_id: '',
      lob_id: '',
      department_id: '',
      start_date: '',
      end_date: '',
      remarks: '',
    }
  }

  componentDidMount() {
    const maintenanceMsg = process.env.REACT_APP_MAINTENANCE_MESSAGE
    if (maintenanceMsg && maintenanceMsg !== '') this.props.showModal('alert', '', maintenanceMsg)
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getProjectInformation(access_token)
    this.props.getLOB(access_token)
    this.props.getCompany(access_token)
    this.props.getDepartment(access_token)
    this.props.getClient(access_token)
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab })
  }

  handleClickRow = (click, id) => {
    this.setState({
      projectID: id,
      project: null,
      redirect: true,
    })
  }

  handleSearch = (data) => {
    let projectInfo = get(this.state, 'defaultProjectInformation')
    if (data === '') {
      if (this.state.selectedStatus !== '') {
        projectInfo = projectInfo.filter((element) => {
          return element.status.toLowerCase() === this.state.selectedStatus.toLowerCase()
        })
      }
    } else {
      projectInfo = projectInfo.filter(searchProjectInformation, data)
      if (this.state.selectedStatus !== '') {
        projectInfo = projectInfo.filter((element) => {
          return element.status.toLowerCase() === this.state.selectedStatus.toLowerCase()
        })
      }
    }
    this.setState({
      projectInformation: projectInfo,
      search: data,
    })
  }

  handleProjectStatus = (e) => {
    let projectInfo = get(this.state, 'defaultProjectInformation')
    projectInfo = projectInfo.filter(searchProjectInformation, this.state.search)
    if (e.target.value !== '') {
      projectInfo = projectInfo.filter((element) => {
        return element.status.toLowerCase() === e.target.value.toLowerCase()
      })
    }
    this.setState({
      projectInformation: projectInfo,
      selectedStatus: e.target.value,
    })
  }

  handleInput = (e) => {
    if (e.target.name === 'company_id') {
      if (e.target.value === '') {
        this.setState({
          company_id: '',
          lob_id: '',
          department_id: '',
        })
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          lob_id: '',
          department_id: '',
        })
      }
    } else if (e.target.name === 'lob_id') {
      if (e.target.value === '') {
        this.setState({
          lob_id: '',
          department_id: '',
        })
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          department_id: '',
        })
      }
    } else this.setState({ [e.target.name]: e.target.value })
  }

  hideForm = () => {
    const managers = this.state.managers.filter(mng => {
      return mng._id === get(this.props, 'authData.user._id') || mng.is_project_approver_role
    })
    this.setState({
      project_type: 'FIXFEE',
      project_approvers: [],
      project_managers: managers ? [...managers] : [],
      client: '',
      project_name: '',
      pm_supervisor: '',
      key_project_manager: '',
      company_id: '',
      lob_id: '',
      department_id: '',
      start_date: '',
      end_date: '',
      remarks: '',
    })
    this.setState({
      showCreateProject: !this.state.showCreateProject,
      showDiscard: !this.state.showDiscard,
    })
  }

  saveProject = () => {
    if (this.state.start_date === '' ||
    this.state.end_date === '' ||
    this.state.project_type === '' ||
    this.state.project_name === '' ||
    this.state.company_id === '' ||
    this.state.lob_id === '' ||
    this.state.client.value === undefined) return

    const payload = {}
    payload.name = this.state.project_name
    payload.start_date = moment(this.state.start_date).format('YYYY-MM-DD')
    payload.end_date = moment(this.state.end_date).format('YYYY-MM-DD')
    payload.project_type = this.state.project_type
    payload.client_id = get(this.state, 'client.value')
    payload.project_supervisor_id = get(this.state, 'pm_supervisor.value')
    payload.key_project_manager_id = get(this.state, 'key_project_manager.value')
    payload.company_id = this.state.company_id
    payload.lob_id = this.state.lob_id
    payload.department_id = this.state.department_id
    payload.description = this.state.remarks
    const approvers = []
    this.state.project_approvers.forEach(p => { approvers.push(p.value) })
    payload.project_approver_ids = approvers
    const managers = []
    this.state.project_managers.forEach(p => { managers.push(p.value) })
    payload.project_manager_ids = managers
    const access_token = localStorage.getItem('access_token')
    this.props.createProjectInformation(payload, access_token)
    this.setState({ showCreateProject: !this.state.showCreateProject })
  }

  selectButton = (confirmType) => {
    if (confirmType === 'createProject') {
      return newProjectButton(
        () => this.saveProject(),
        () => this.setState({ showDiscard: !this.state.showDiscard })
      )
    } else if (confirmType === 200) {
      return buttonSuccess(confirmType, (type) => this.props.hideConfirm(type))
    } else if (confirmType === 'Error') {
      return buttonTryAgain(confirmType, (type) => this.props.hideConfirm(type))
    }
    return null
  }

  handleProjectManager = e => {
    const { key_project_manager } = this.state
    const keyPM = key_project_manager ? e.find(pm => pm.value === key_project_manager.value) : null
    if (!keyPM) this.setState({ project_managers: e, key_project_manager: null })
    else this.setState({ project_managers: e })
  }

  render() {
    const IsFetching = get(this.props, 'getIsFetching')
    const projects = this.state.projectInformation
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsPMUser = get(this.props, 'authData.user.is_pm_role')
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')
    const IsSalesUser = get(this.props, 'authData.user.is_salesman_role')
    const IsProjectApproverUser = get(this.props, 'authData.user.is_project_approver_role')

    const { redirect } = this.state
    if (redirect) {
      get(this.props, 'history').push('/project_information')
      return (<Redirect to={ {
        pathname: `/project_information/${this.state.projectID}`,
        state: { header: 'Project Information' },
      } }
      />)
    }
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
      || get(this.props, 'redirectProject.isAuthenticated')
    const redirectToLogin = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectProject.redirect')
    if (redirectToLogin) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsLOBLeadUser !== undefined &&
      IsSystemUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      IsManagementUser !== undefined &&
      IsPMUser !== undefined &&
      IsAdminUser !== undefined &&
      IsAccountantUser !== undefined &&
      IsProjectApproverUser !== undefined &&
      IsSalesUser !== undefined &&
      !(IsLOBLeadUser || IsSystemUser || IsHRConfidentialUser || IsManagementUser || IsPMUser || IsAdminUser || IsAccountantUser || IsProjectApproverUser || IsSalesUser)) window.location = '/home'

    const confirmType = get(this.props, 'confirmType')
    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmMessage = get(this.props, 'confirmMessage')
    const isOpenManual = get(this.props, 'isOpenManual')

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isOpenManual &&
        <Manual
          isOpen={ isOpenManual }
          typeManual={ this.props.typeManual }
          closeManual={ this.props.closeManual }
          setTypeManual={ this.props.setTypeManual }
        />
        }
        <CustomModalMessage
          hide={ () => this.props.hideConfirm(confirmType) }
          show={
            confirmType === 'createSuccess'
            || confirmType === 'confirmClose'
          }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus) }
        />
        { this.state.showDiscard &&
          <DiscardProjectForm
            open={ this.state.showDiscard }
            toggle={ () => this.setState({ showDiscard: !this.state.showDiscard }) }
            hideForm={ this.hideForm }
          />
        }
        <SearchbarProject
          selectedStatus={ this.state.selectedStatus }
          toggleCreate={ () => this.setState({ showCreateProject: !this.state.showCreateProject }) }
          handleSearch={ this.handleSearch }
          handleProjectStatus={ this.handleProjectStatus }
          export={ () => this.props.exportProjectInformation(localStorage.getItem('access_token')) }
        />
        <CustomModal
          hide={ () => this.props.hideModal('alert') }
          show={ get(this.props, 'modalType') === 'alert' }
          type={ get(this.props, 'modalStatus') }
          message={ get(this.props, 'modalMessage') }
          fontColor='black'
        />
        { this.state.showCreateProject &&
          <ProjectForm
            open={ this.state.showCreateProject }
            button={ this.selectButton('createProject') }
            { ...this.state }
            toggle={ () => this.setState({ showDiscard: !this.state.showDiscard }) }
            keyPress={ () => this.setState({ showDiscard: !this.state.showDiscard }) }
            handleInput={ this.handleInput }
            handleChangeStartDate={ (e) => this.setState({ start_date: e }) }
            handleChangeEndDate={ (e) => this.setState({ end_date: e }) }
            handleProjectApprover={ (e) => this.setState({ project_approvers: e }) }
            handleProjectManager={ this.handleProjectManager }
            handleSupervisor={ (e) => this.setState({ pm_supervisor: e }) }
            handleKeyPM={ e => this.setState({ key_project_manager: e }) }
            handleClient={ (e) => this.setState({ client: e }) }
            cancelForm={ this.hideForm }
          />
        }
        { IsFetching &&
        <Overlay>
          <OverlayWrapper>
            <BeatLoader
              css={ css(`
                position: absolute;
                left: 50%;
                top: 50%;
              `) }
              sizeUnit={ "px" }
              size={ 15 }
              color={ '#D44B49' }
              loading={ IsFetching }
            />
          </OverlayWrapper>
        </Overlay>
        }
        { !IsFetching &&
        <ProjectTable
          handleClickRow={ this.handleClickRow }
          projects={ projects }
        /> }
      </Wrapper>
    )
  }
}

ProjectPage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  closeManual: PropTypes.func.isRequired,
  getProjectInformation: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  getDepartment: PropTypes.func.isRequired,
  getClient: PropTypes.func.isRequired,
  createProjectInformation: PropTypes.func.isRequired,
  exportProjectInformation: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectProject: projectInformationSelector.redirectProject,
  getProjectInformationData: projectInformationSelector.getProjectInformationData,
  createProjectInformationData: projectInformationSelector.createProjectInformationData,
  getIsFetching: projectInformationSelector.getIsFetching,
  isOpenManual: projectInformationSelector.isOpenManual,
  typeManual: projectInformationSelector.getTypeManual,
  getExportURL: projectInformationSelector.getExportURL,
  getLOBData: lobSelector.getListLOB,
  getCompanyData: companySelector.getListCompany,
  getDepartmentData: departmentSelector.getListDepartment,
  getClientData: clientMasterSelector.getClientData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getProjectInformation: projectInformationAction.getProjectInformation,
  resetGetProjectInformation: projectInformationAction.resetGetProjectInformation,
  createProjectInformation: projectInformationAction.createProjectInformation,
  resetCreateProjectInformation: projectInformationAction.resetCreateProjectInformation,
  closeManual: projectInformationAction.closeManual,
  setTypeManual: projectInformationAction.setTypeManual,
  getLOB: lobAction.getLOB,
  getCompany: companyAction.getCompany,
  getDepartment: departmentAction.getDepartment,
  getClient: clientMasterAction.getClient,
  exportProjectInformation: projectInformationAction.exportProjectInformation,
  resetExportProjectInformation: projectInformationAction.resetExportProjectInformation,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(ProjectPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/project/index.js